import React, { useEffect, useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useStoreon } from 'storeon/react';

import DealerContactInformationMiwindows from "../../DealerContactInformationMiwindows";
import InformationAboutYourClient from '../../InformationAboutYourClient';
import WhoToContact from "../../WhoToContact";

import Btn from "../../Btn";
import Info from "../../Info";
import axios from "axios";
import BlockDescribeProblemServiceRequestDealerMiwindows from "../../BlockDescribeProblemServiceRequestDealerMiwindows";
import Information from "../../Information";
import Loader from '../../Loader';

const ServiceRequestDealerMiwindowsForm = ( { id } ) => {
    const [serverResponse, setServerResponse] = useState( '' );
    const [submitForm , setSubmitForm] = useState(false);

    const methods = useForm( {
        mode: 'all',
        reValidateMode: 'onChange',
        // Default values for field array.
        defaultValues: {
            your_project: [{}],
        },
    } );
    const { errors, trigger, handleSubmit, formState } = methods;

    const onSubmit = ( data ) => {
        const endpointUrl = `${window.location.origin}/sr/api`;
        setSubmitForm(true);

        axios( {
            method: 'post',
            url: endpointUrl,
            data: data,
            config: {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            },
        } )
            .then( ( response ) => {
                if ( response.status === 200 ) {
                    window.location.href = `${window.location.origin}${window.location.pathname.replace( /\/+$/, '' )}/submission`;
                }
            } )
            .catch( ( error ) => {
                setServerResponse( error.response.data );
                setSubmitForm(false);
                console.log( error );
            } );
    }
    const { dispatch, groups } = useStoreon( 'groups' );
    /**
     * Trigger form validation on component init.
     * This action will pre-populate errors object.
     */
    useEffect( () => {
        trigger();
    }, [trigger] );

    /**
     * Check form errors and determine if fieldset should be disabled.
     */
    useEffect( () => {
        for ( let i = 1; i < groups.length; i += 1 ) {
            const { fields: groupFields } = groups[i - 1];
            const isValid = Object.keys( errors ).some( ( item ) => groupFields.includes( item ) );
            if ( groups[i].disabled === !isValid ) {
                dispatch( 'CHANGE_FIELDSET_STATE', { id: i, disabled: isValid } );
            }
        }
    } );

    return (
        <div className={`service-request-form container`}>
            <FormProvider {...methods}>
                <form onSubmit={handleSubmit( onSubmit )}>
                    <h1 className={'title-big'}>Service Request</h1>
                    <Info styleText={'text-grey'}>
                        Need to schedule service for Mi windows or patio doors? Fill out the form below and our
                        service team will contact you soon.
                    </Info>
                    <DealerContactInformationMiwindows index={0}/>
                    <InformationAboutYourClient index={1}/>
                    <WhoToContact index={2}/>
                    <BlockDescribeProblemServiceRequestDealerMiwindows disabled={groups[2].disabled} index={3} idForm={id}/>
                    <Information index={4}/>
                    <Btn disabled={!formState.isValid || submitForm}><input type="submit" value={'Request Service'}/></Btn>
                    {serverResponse && <div className="server-error">{serverResponse}</div>}
                </form>
            </FormProvider>
            {submitForm && <Loader />}
        </div>
    );
};

export default ServiceRequestDealerMiwindowsForm;
